import { Link } from "@tanstack/react-router";

import { t } from "../i18n";
import { Container } from "./ui";

/**
 * Site-wide footer. Lives at the bottom of every screen — authenticated
 * AppShell, unauthenticated AuthShell (login, register, password recovery),
 * and the standalone legal pages (/personvern, /vilkar).
 *
 * Always-visible footer matters here for one specific reason: links to the
 * privacy notice and ToS must be reachable BEFORE a user signs up (GDPR
 * Art. 13 — informed before collection), not only from inside the app
 * shell after authentication.
 */
export function Footer() {
  return (
    <footer className="mt-8 border-ink-200 border-t bg-surface">
      <Container>
        <div className="flex flex-row items-center justify-between gap-3 py-5 text-ink-500 text-xs">
          <span className="min-w-0">{t.footer.securityNote}</span>
          <nav className="flex shrink-0 items-center gap-4">
            <Link
              to="/personvern"
              className="text-ink-600 underline-offset-4 hover:text-ink-900 hover:underline"
            >
              {t.footer.privacy}
            </Link>
            <Link
              to="/vilkar"
              className="text-ink-600 underline-offset-4 hover:text-ink-900 hover:underline"
            >
              {t.footer.terms}
            </Link>
          </nav>
        </div>
      </Container>
    </footer>
  );
}
